import React from "react";

// Sections
import Navigation from "./sections/navigation";
import Header from "./sections/header";
import Helmet from "./sections/helmet";
import About from "./sections/about";
import Client from "./sections/client";
import Challenges from "./sections/challenges";
import Criteria from "./sections/criteria";
import Timeline from "./sections/timeline2";
import Workshop from "./sections/workshop";
import Reasons from "./sections/reasons";
import FAQ from "./sections/faq";
import Contact from "./sections/contact";
import Footer from "./sections/footer";

export default () => {
  return (
    <div className="page">
      <Helmet />
      <div
        id="home"
        className="pwg-section gradiant-background header-section section header-software header-flat"
      >
        <Navigation />
        <Header />
      </div>
      <About />
      <Client />
      <Challenges />
      <Criteria />
      <Timeline />
      <Workshop />
      <Reasons />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};
